export const getPurchaseChargeDraft = (draft, items = [], costHeads = []) => ({
  cost_head_id: costHeads[0]?.id || '',
  base_amount: '',
  gst_amount: '',
  notes: '',
  ...draft,
  // Editing another field can create a draft before the item is explicitly selected.
  purchase_order_item_id: draft?.purchase_order_item_id || items[0]?.id || '',
});
